import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-7af53884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative overflow-hidden" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-10" }
const _hoisted_3 = { class: "flex flex-row p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_5 = {
  key: 7,
  class: "flex flex-col justify-center place-items-center py-10 w-full h-full sl-intro-background text-center text-white sl-intro-background"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-md mt-6" }
const _hoisted_8 = { class: "mt-6 text-xl font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Intro = _resolveComponent("Intro")!
  const _component_PlayersReady = _resolveComponent("PlayersReady")!
  const _component_Instruction = _resolveComponent("Instruction")!
  const _component_Sequence = _resolveComponent("Sequence")!
  const _component_RetellDetail = _resolveComponent("RetellDetail")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.mode !== _ctx.MODES.retell)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.players, (p) => {
              return (_openBlock(), _createBlock(_component_Avatar, {
                key: p._id,
                layout: p.profile.avatar,
                class: "w-24 h-24 -mr-6"
              }, null, 8 /* PROPS */, ["layout"]))
            }), 128 /* KEYED_FRAGMENT */))
          : (_ctx.currentPlayer)
            ? (_openBlock(), _createBlock(_component_Avatar, {
                key: 1,
                layout: _ctx.currentPlayer.profile.avatar,
                class: "w-24 h-24 -mr-6"
              }, null, 8 /* PROPS */, ["layout"]))
            : _createCommentVNode("v-if", true),
        _createVNode(_component_Button, {
          class: "pointer-events-auto ml-6 bg-white m-6",
          childclass: 'w-12 h-12',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.finish()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        (_ctx.mode === _ctx.MODES.intro)
          ? (_openBlock(), _createBlock(_component_Intro, {
              key: 0,
              title: _ctx.t('title'),
              description: '',
              "exercise-index": '',
              image: _ctx.retellImage
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  backgroundcolour: 'bg-sl-green-button',
                  textcolour: 'text-white',
                  childclass: 'text-2xl border-none h-16 w-56',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMode(_ctx.MODES.instruction)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('getStarted')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "image"]))
          : (_ctx.mode === _ctx.MODES.playerReady)
            ? (_openBlock(), _createBlock(_component_PlayersReady, {
                key: 1,
                description: _ctx.t('playTogether'),
                players: _ctx.players
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    backgroundcolour: 'bg-sl-green-button',
                    textcolour: 'text-white',
                    childclass: 'text-2xl border-none h-16 w-56',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMode(_ctx.MODES.instruction)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('weReady')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["description", "players"]))
            : (_ctx.mode === _ctx.MODES.instruction)
              ? (_openBlock(), _createBlock(_component_Instruction, {
                  key: 2,
                  onPlaysound: _ctx.playInstruction
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      backgroundcolour: 'bg-sl-green-button',
                      textcolour: 'text-white',
                      childclass: 'text-2xl border-none h-16 w-56',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMode(_ctx.MODES.sequence)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onPlaysound"]))
              : (_ctx.mode === _ctx.MODES.sequence)
                ? (_openBlock(), _createBlock(_component_Sequence, {
                    key: 3,
                    question: _ctx.question
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none p-5',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeMode(_ctx.MODES.tell)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('playTheStory')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["question"]))
                : (_ctx.mode === _ctx.MODES.tell)
                  ? (_openBlock(), _createBlock(_component_RetellDetail, {
                      key: 4,
                      sett: _ctx.selectedSet,
                      question: _ctx.question,
                      mode: _ctx.MODES.tell,
                      onPageupdate: _ctx.tellPageChanged
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Button, {
                          backgroundcolour: 'bg-sl-green-button',
                          textcolour: 'text-white',
                          childclass: 'text-2xl border-none p-5 pt-2',
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMode(_ctx.MODES.yourTurn)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('continue')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["sett", "question", "mode", "onPageupdate"]))
                  : (_ctx.mode === _ctx.MODES.yourTurn)
                    ? (_openBlock(), _createBlock(_component_Intro, {
                        key: 5,
                        title: _ctx.t('ytTitle'),
                        description: _ctx.t('ytDescription'),
                        image: _ctx.yourTurnImage
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            class: "my-8",
                            backgroundcolour: 'bg-sl-green-button',
                            textcolour: 'text-white',
                            childclass: 'text-2xl border-none h-16 w-56',
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeMode(_ctx.MODES.retell)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('continue')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["title", "description", "image"]))
                    : (_ctx.currentPlayer && _ctx.mode === _ctx.MODES.retell)
                      ? (_openBlock(), _createBlock(_component_RetellDetail, {
                          key: 6,
                          question: _ctx.question,
                          sett: _ctx.selectedSet,
                          player: _ctx.currentPlayer,
                          mode: _ctx.MODES.retell,
                          onPageupdate: _ctx.retellPageChanged
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              backgroundcolour: 'bg-sl-green-button',
                              textcolour: 'text-white',
                              player: _ctx.currentPlayer,
                              childclass: 'text-2xl border-none p-5',
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeMode(_ctx.MODES.videoname)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('done')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["player"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["question", "sett", "player", "mode", "onPageupdate"]))
                      : (_ctx.mode === _ctx.MODES.videoname)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.question.pages.length)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "relative rounded-2xl w-80 h-80 bg-cover bg-center",
                                  style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.question.pages[0].image + ')' })
                                }, [
                                  (_ctx.completed)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.radioImage,
                                        class: "absolute z-10 w-32 top-0 -right-24 transform rotate-12",
                                        alt: "Discussion Time icon"
                                      }, null, 8 /* PROPS */, _hoisted_6))
                                    : _createCommentVNode("v-if", true)
                                ], 4 /* STYLE */))
                              : _createCommentVNode("v-if", true),
                            (_ctx.completed)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createCommentVNode("p class=\"mt-6 text-5xl font-bold\">{{ videoName }}</p"),
                                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('congratsDescription')), 1 /* TEXT */),
                                  _createVNode(_component_Button, {
                                    class: "mt-6",
                                    backgroundcolour: 'bg-sl-green-button',
                                    textcolour: 'text-white',
                                    childclass: 'text-2xl border-none p-5',
                                    onVclick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.finish()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('done')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t('findAName')), 1 /* TEXT */),
                                  _createVNode(_component_AnswerInput, {
                                    modelValue: _ctx.videoName,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.videoName) = $event)),
                                    class: "mt-6 text-black",
                                    mode: "text",
                                    border: true
                                  }, null, 8 /* PROPS */, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    class: "mt-6",
                                    disabled: _ctx.videoName === '',
                                    backgroundcolour: 'bg-sl-green-button',
                                    textcolour: 'text-white',
                                    childclass: 'text-2xl border-none p-5',
                                    onVclick: _ctx.confirmVideoName
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["disabled", "onVclick"])
                                ], 64 /* STABLE_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}